// This icon file is generated automatically.
var PInfoOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 12 12", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M5 1.5a1 1 0 102 0 1 1 0 00-2 0zm1.5 2.63h-1a.13.13 0 00-.13.12v7.25c0 .07.06.13.13.13h1c.07 0 .13-.06.13-.13V4.25a.13.13 0 00-.13-.13z", "fill-rule": "nonzero" } }] }, "name": "p-info", "theme": "outlined" };
export default PInfoOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PInfoOutlined.js
// module id = 3467
// module chunks = 0